type Canceler = (message?: string) => void;

export class Cancel {
    static __CANCEL__ = true;

    constructor(public message: string) {}

    public toString() {
        return "Cancel" + (this.message ? ": " + this.message : "");
    }
}

export function isCancel(value: any) {
    return !!(value && value.__CANCEL__);
}

export interface CancelTokenSource {
    token: CancelToken;
    cancel: Canceler;
}

export class CancelToken {
    static source() {
        let cancel: any;
        const token = new CancelToken((c) => { cancel = c; });

        return {
            token,
            cancel,
        };
    }

    public promise: Promise<Cancel>;
    public reason: Cancel | null = null;

    constructor(executor: (resolve: (value?: any) => void, reject?: (reason?: any) => void) => void ) {
        let resolvePromise: any;

        this.promise = new Promise((resolve) => {
            resolvePromise = resolve;
        });

        executor((message) => {
            if (this.reason) {
                return;
            }

            this.reason = new Cancel(message);
            resolvePromise(this.reason);
        });
    }

    public throwIfRequested() {
        if (this.reason) {
            throw this.reason;
        }
    }
}
